"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoInvitePromoElementShownRaw = void 0;
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** None */
const autoInvitePromoElementShown = (element, { vacancyId, ...analyticsParams }) => analytics_js_1.default.sendHHEventElementShown(element, { elementName: "auto_invite_promo", vacancyId, ...analyticsParams });
/** None. Для разовой отправки, например в onHover у HoverTip */
const autoInvitePromoElementShownRaw = ({ vacancyId, ...analyticsParams }) => analytics_js_1.default.sendHHEvent('element_shown', { elementName: "auto_invite_promo", vacancyId, ...analyticsParams });
exports.autoInvitePromoElementShownRaw = autoInvitePromoElementShownRaw;
exports.default = autoInvitePromoElementShown;
